<template>
  <div class="page view_debug">

    <div class="zone routes">
      <p>Debug Page</p>

      <ul>
        <li><router-link to="/">Home</router-link></li><br>
        <li><router-link to="/tutorial">Tutorial</router-link></li><br>
        <li><router-link to="/BorneHeader">BorneHeader</router-link></li><br>
        <li><router-link to="/geolocation" >Geolocation</router-link></li><br>
        <li><router-link :to="{name: 'Geolocation', params: {place: 'place2'}}" >Geolocation place 2</router-link></li><br>
        <li><router-link :to="{name: 'Geolocation', params: {place: 'place3'}}" >Geolocation place 3</router-link></li><br>
        <li><router-link :to="{name: 'Geolocation', params: {place: 'place4'}}" >Geolocation place 4</router-link></li><br>
        <li><router-link to="/qrcode">QRCode</router-link></li><br>
        <li><router-link to="/place">Place</router-link></li><br>
        <li><router-link to="/lastpanel">LastPanel</router-link></li><br>
        <li><a href="/static/360.html">Vue 360</a></li><br>
      </ul>
    </div>
    <div class="zone actions">
      <p>Debug actions</p>
      <ul>
        <a @click="resetGeolocationPlace" href="#">Reset du parcours</a>
      </ul>
    </div>

  </div>
</template>

<script>

export default {
  name: 'home',
  components: {},
  data: () => ({
  }),
  methods: {
    resetGeolocationPlace: function() {
      console.log('Location deleted')
      window.localStorage.removeItem("target");
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>


  .debug_link {
    // display: none;
  }

  .page {
    display: flex;
    justify-content: center;
    overflow: scroll;

    .routes {
      margin-right: 100px;
    }
  }

  ul {
    list-style: none;
    padding-left: 0;

    li {
      margin-bottom: 5px;

      a {
        color: black;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/Debug.vue